import axios from 'axios';
import { apiClient } from './index';
import { API_URL } from './index';

/** Refresh with token in body (legacy). */
export const refreshTokenRequest = async (refreshToken: string) => {
    return axios.post<{
        access_token: string;
        refresh_token: string;
    }>(`${API_URL}/auth/refresh`, { refresh_token: refreshToken }, { withCredentials: true });
};

/** Refresh using httpOnly cookie only (no body). Use apiClient so cookies are sent. */
export const refreshTokenRequestWithCookies = async () => {
    return apiClient.post<{ access_token: string; refresh_token: string }>('/auth/refresh', {}, { withCredentials: true });
};
